import { MakeCopy16 } from 'ui/icons/aurora/16px/MakeCopy16';
import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { ButtonProps } from 'modules/queryBuilder/contexts';
import { BUTTON_VARIANTS } from 'ui/button';
import { QueryBuilderIconButton } from './QueryBuilderIconButton';
import { ConditionActionButtonProps } from './types';

export const DATA_TEST = {
  conditionButton: 'duplicate-condition-button',
  criteriaButton: 'duplicate-criteria-button',
  requirementButton: 'duplicate-requirement-button',
};

type DuplicateButtonProps = Omit<ConditionActionButtonProps, 'Icon'>;

export const DuplicateButton = ({
  dataTest,
  ...props
}: DuplicateButtonProps & { dataTest: string }) => {
  const { t } = useTranslation();

  return (
    <QueryBuilderIconButton
      {...props}
      dataTest={dataTest}
      tooltipContent={t('storybook.buttons.tooltips.duplicate')}
      Icon={MakeCopy16}
    />
  );
};

// Variants
export const DuplicateConditionButton = (props: ButtonProps) => (
  <DuplicateButton
    {...props}
    variant={BUTTON_VARIANTS.GHOST}
    dataTest={DATA_TEST.conditionButton}
  />
);

export const DuplicateRequirementButton = (props: ButtonProps) => (
  <DuplicateButton {...props} dataTest={DATA_TEST.requirementButton} />
);

export const DuplicateCriteriaButton = (props: ButtonProps) => (
  <DuplicateButton {...props} dataTest={DATA_TEST.criteriaButton} />
);
